'use client';

// Solid variant of the headphones glyph from IntroLinkCards.tsx — the band
// stays a thin stroke, the ear cups are filled.
export default function AudioIcon({ strokeWidth = 1.5 }: { strokeWidth?: number }) {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    role="img"
  >
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
    <path fill="currentColor" d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
  </svg>
}
